import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TableComponent } from '../../../components/table/table.component';
import { TableColumn } from 'types/table-column.interface';
import { Router } from '@angular/router';
import { API_READING_ROOM, ApiService } from 'services/api.service';
import { NgClass } from '@angular/common';
import { CLAIM_SCOPES, CLAIM_TYPES } from 'types/user.interface';
import { ClaimDirective } from 'src/app/directive/claim.directive';
@Component({
  selector: 'app-reading-room-list-page',
  standalone: true,
  imports: [TranslateModule, TableComponent, NgClass, ClaimDirective],
  templateUrl: './reading-room-list-page.component.html',
  styleUrl: './reading-room-list-page.component.scss'
})
export class ReadingRoomListPageComponent {
  public readonly CLAIM_SCOPE = CLAIM_SCOPES['readingRoom'];
  public readonly CLAIM_TYPES = CLAIM_TYPES;
  public readonly apiPath = API_READING_ROOM;
  isExcelDownloading: boolean = false;

  constructor(
    private router: Router,
    private apiService: ApiService
  ) {}

  tableColumns: TableColumn[] = [
    {
      name: 'pages.readingRoom.tableColumns.name',
      key: 'name',
      sortKey: 'name',
      sortEnabled: true
    },
    {
      name: 'pages.readingRoom.tableColumns.address',
      key: 'address',
      sortKey: 'address',
      sortEnabled: true
    },
    {
      name: 'pages.readingRoom.tableColumns.email',
      key: 'email',
      sortKey: 'email',
      sortEnabled: true
    },
    {
      name: 'pages.readingRoom.tableColumns.phone',
      key: 'contactPhone',
      sortKey: 'contactPhone',
      sortEnabled: true
    }
  ];

  navigateToAddPage() {
    this.router.navigate(['/lasitavas/pievienot']);
  }

  getExcelFile() {
    if (!this.isExcelDownloading) {
      this.isExcelDownloading = true;
      this.apiService.getReadingRoomExcel().subscribe(
        (data: any) => {
          if (data) {
            this.saveExcelFile(data);
            this.isExcelDownloading = false;
          }
        },
        (error: any) => {
          console.error(error);
        }
      );
    }
  }

  saveExcelFile(blob: Blob): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'lasitavas.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
}
